export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL as string) || 'http://hr_v2-laravel-backend.test/api/v1';
